import { RATING_FORM_UI_VERSION_TS1_V3, RATING_FORM_UI_VERSION_TS1_V4 } from "src/app/constant";

/** Which offline rating calculator to use for a TS-1 `ratingFormVersion`. */
export type Ts1RatingCalcKey = "v2" | "v3" | "v4";

export const TS1_RATING_FORM_REGISTRY = {
	[RATING_FORM_UI_VERSION_TS1_V3]: { calc: "v3" as const },
	[RATING_FORM_UI_VERSION_TS1_V4]: { calc: "v4" as const },
} as const;

/** Resolve calculator key from a draft's `ratingFormVersion`. Defaults to v2 for legacy shells. */
export function resolveTs1RatingCalcKey(ratingFormVersion?: number | null): Ts1RatingCalcKey {
	const version = Number(ratingFormVersion);
	const entry = TS1_RATING_FORM_REGISTRY[version as keyof typeof TS1_RATING_FORM_REGISTRY];
	return entry?.calc ?? "v2";
}
